module.exports = __webpack_public_path__ + "static/img/2296_phase_function_Paper_Points.28dd59f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2296_phase_function_Paper_Points.png
// module id = q8Q0
// module chunks = 0